import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import {
	type DocumentListResponseDTO,
	deleteDocumentIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useDocumentDeleteMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((id: number) => deleteDocumentIdV2(id)),
		onMutate: async (id: number) => {
			await queryClient.cancelQueries({ queryKey: DocumentKeys.allLists });

			const previousQueries =
				queryClient.getQueriesData<DocumentListResponseDTO>({
					queryKey: DocumentKeys.allLists,
				});

			for (const [queryKey, data] of previousQueries) {
				if (data) {
					queryClient.setQueryData(queryKey, {
						...data,
						documents: data.documents.filter((doc) => doc.id !== id),
					});
				}
			}

			return { previousQueries };
		},

		onError: (_err, _id, context) => {
			if (context?.previousQueries) {
				for (const [queryKey, data] of context.previousQueries) {
					queryClient.setQueryData(queryKey, data);
				}
			}
		},

		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: DocumentKeys.allLists });
		},
	});
};
